import SignaturePad from 'signature_pad';

const addSignaturePad = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const signatureWrapper = document.querySelector('.signature-pad');
    const signatureCanvas = signatureWrapper.querySelector('canvas');
    const signatureInput = signatureWrapper.querySelector('input');
    const resetSignature = document.querySelector('#reset-signature');

    const setSignatureCanvasWidth = () => {
      signatureCanvas.width = document.querySelector('#new_complaint').offsetWidth;
    };

    const padToInput = event => {
      signatureInput.value = signaturePad.toDataURL();
    };

    const signaturePad = new SignaturePad(signatureCanvas, {
      onEnd: padToInput,
    });

    const clearSignature = () => {
      signaturePad.clear();
      signatureInput.value = '';
    };

    // Set SignaturePad width on load
    setTimeout(setSignatureCanvasWidth, 500);

    // Responsive
    // window.onresize = () => setSignatureCanvasWidth && clearSignature();
    window.onresize = () => setSignatureCanvasWidth();

    // Reset Signature
    resetSignature.addEventListener('click', event => {
      event.preventDefault();

      clearSignature();
    });
  });
}

if ($('.signature-pad--body').length > 0 ) {
  addSignaturePad();
}